const settlment = (value, amount) => {
  let val = parseInt(value, 10);
  let amt = parseInt(amount, 10);
  if (val <= 0) {
    return "Settled amount must be greater then 0.";
  } else if (!value) {
    return "This field is mandatory.";
  } else if (val > amt) {
    return "Settled amount can't be more than pending amount";
  } else {
    return null;
  }
};
export default settlment;



// WEBPACK FOOTER //
// ./src/components/Finance/validateSettlment.js